<template>
  <section
    class="the-trial-of-service-doers-wrap"
    v-parallax
    :key="$route.name"
  >
    <v-page
      background="images/six-trials-of-God-s-judgment-work/index/six-trials-of-God-s-judgment-work-bg-1.jpg"
      class="page-index"
      v-parallax-background
      v-skip="$route.name"
      v-slide-up-in
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        :stageTitle="firstPageData.stage"
        v-slide-up-in-stage="1"
        v-if="chapterTitle"
      >
        <v-stage-cards
          :key="i"
          :images="poster(i)"
          :title="item.num + space + item.title"
          :slug="'/six-trials-of-God-s-judgment-work/' + item.slug"
          :count="childrenNavData.length"
          v-for="(item, i) in childrenNavData"
        />
      </v-chapter-title>
      <v-text-content :html="this.introContent" v-slide-up-in-stage="2" />
    </v-page>

    <v-page :background="theme.colors.cyan" v-slide-up-in>
      <v-sub-chapter-index-page
        :pageData="pageDataItem.page0.data"
        v-slide-up-in-stage="1"
      />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page2ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page1.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page2.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page3.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page3ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page4.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page5ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page5.data"
      />
    </v-page>

    <v-page>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page4ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page6.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page7.data.content"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-float-image-content :data="pageDataItem.page8.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page7ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page9.data"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-text-content :html="pageDataItem.page10.data.content" />
    </v-page>

    <v-page link-above>
      <v-full-screen-paint
        paintPath="images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page9ImageViewer.jpg"
        :fullScreenPaintData="pageDataItem.page11.data"
      />
    </v-page>

    <v-page>
      <v-text-content
        :isGodsWord="true"
        :html="pageDataItem.page12.data.content"
      ></v-text-content>
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-full-screen-songs-player
        :data="pageDataItem.page14.data"
        bg="images/common/hymnsPosters/six-trials-of-God-s-judgment-work-1.jpg"
      />
    </v-page>

    <v-page :background="theme.colors.cyan">
      <v-chatper-entry />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      childrenNavData: [],
      introContent: "",
      chapterTitle: "",
      firstPageData: {},
      space: "&nbsp;&nbsp;&nbsp;&nbsp;",
    };
  },
  created() {
    this.pageDataItem = this.schema[this.get_router_name()].item;

    this.childrenNavData = this.schema[this.get_router_name()].item.index.data;
    this.introContent = this.schema[this.get_router_name()].item[
      "index-introduction"
    ].data.content;
    this.chapterTitle = this.schema[this.get_router_name()].item.index.title;

    this.firstPageData = this.schema.global.item.aside.data[4];
  },
  mounted() {
    //  处理中外文全角半角空格
    this.$P.isLatin && (this.space = "&nbsp;&nbsp;");
  },
  methods: {
    /**
     * 循环遍历出各子阶段缩略图
     */
    poster(i) {
      return `images/six-trials-of-God-s-judgment-work/index/poster-${i +
        1}.jpg`;
    },
  },
};
</script>
